import React, { useEffect } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { TOKEN_SENT_SUCCESSFULLY, USERNAME } from "../../../ducks/forgotPassword";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Container, FormControl, FormLabel } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";
import { Link, useLocation } from "react-router-dom";
import { createSuccessMessages } from "../../../ducks/message";
import StandardView from "../../common/StandardView";

const ForgotPassword = ({
  username,
  propertyChange,
  tokenSentSuccessfully,
  validateToken,
  clearMessages,
  requestPasswordReset
}) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tokenSubmitted = query && query.get("token");

  useEffect(() => {
    if (tokenSubmitted) {
      validateToken(tokenSubmitted);
    }
    clearMessages();

    return () => {
      propertyChange(TOKEN_SENT_SUCCESSFULLY, undefined);
      propertyChange(USERNAME, undefined);
      clearMessages();
    };
  }, [tokenSubmitted, clearMessages, propertyChange, validateToken]);

  if (tokenSentSuccessfully) {
    createSuccessMessages();
  }

  return (
    <StandardView id={"forgotPassword"} titleKey={"login.forgot.password.page.title"}>
      <Button as={Link} size="sm" variant="link" to="/login">
        <FontAwesomeIcon className="me-2" icon={faChevronLeft} />
        <FormattedMessage id="login.back.to.login.page" />
      </Button>

      {tokenSentSuccessfully === undefined && (
        <Container>
          <h5>
            <FormattedMessage id="login.please.enter.your.username" />
          </h5>
          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="login.placeholder.username" />
            </FormLabel>
            <FormControl
              name="username"
              autoFocus
              required
              type="text"
              value={username || ""}
              onChange={(event) => {
                propertyChange("username", event.currentTarget.value);
              }}
            />
            <FormControl.Feedback />
          </FormGroup>
          <Button onClick={requestPasswordReset} disabled={!username}>
            <FormattedMessage id="app.common.action.submit" />
          </Button>
        </Container>
      )}
    </StandardView>
  );
};

ForgotPassword.propTypes = {
  username: PropTypes.string,
  newPassword: PropTypes.string,
  newPasswordConfirm: PropTypes.string,
  newPasswordIsValid: PropTypes.bool,
  newPasswordConfirmIsValid: PropTypes.bool,
  tokenInvalid: PropTypes.bool,
  tokenSentSuccessfully: PropTypes.bool,

  locale: PropTypes.string,

  propertyChange: PropTypes.func.isRequired,
  requestPasswordReset: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  validateToken: PropTypes.func,

  clearMessages: PropTypes.func,

  intl: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(ForgotPassword);
